export var getters = {
    applicationForm: function (state) {
        return state.forms.find(function (form) { return (form === null || form === void 0 ? void 0 : form.type) === 'application'; });
    },
};
